import { render, staticRenderFns } from "./Logo1000grad.vue?vue&type=template&id=073b77f9&scoped=true&"
import script from "./Logo1000grad.vue?vue&type=script&lang=js&"
export * from "./Logo1000grad.vue?vue&type=script&lang=js&"
import style0 from "./Logo1000grad.vue?vue&type=style&index=0&id=073b77f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073b77f9",
  null
  
)

export default component.exports